<template>
    <div :class="{'loading': loading}">
        <div class="products row" >
            <shop-item v-for="item in this.products" :item="item" :key="item.id">
            </shop-item>
        </div>
    </div>
</template>

<script>
    export default {

        data: function () {
            return {
                loading: true,
                products : []
            }
        },
        mounted() {
            this.loadProducts();
        },
        methods: {
            loadProducts: function() {
                axios.get('/api/products', {

                })
                .then((response) => {
                    this.products = response.data.data;
                    this.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>
